import React, { useEffect, useRef } from 'react';

const Banner2 = () => {
  const bannerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            entry.target.classList.add('show');
          } else {
            entry.target.classList.remove('show');
          }
        }
      },
      {
        threshold: 0.1, // 10% 이상 보일 때 실행
      }
    );

    observer.observe(bannerRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="banner2" ref={bannerRef}>
      Banner2
    </div>
  );
};

export default Banner2;
